import type { CSSProperties } from 'react';

import { CARD_PADDING_PX } from '../components/CollectionButtonCard';

/** Space between the header text and the divider, and the divider and the rail. */
const HEADER_DIVIDER_GAP_PX = 8;

/**
 * The collection module's header row style — the name / chevrons line, closed
 * by a divider that runs the full width of the card (Figma): the row cancels
 * the card's own inset with negative margins and re-applies it as padding, so
 * the rule reaches both edges while the text stays aligned with the content
 * below it.
 *
 * One definition for both dispatch paths — the visitor
 * {@link CollectionButtonRackView} and the owner editor's `CollectionHeader` —
 * so the divider can't drift between them.
 */
export function collectionButtonHeaderStyle(
  dividerColor: string,
): CSSProperties {
  return {
    marginLeft: -CARD_PADDING_PX,
    marginRight: -CARD_PADDING_PX,
    paddingLeft: CARD_PADDING_PX,
    paddingRight: CARD_PADDING_PX,
    paddingBottom: HEADER_DIVIDER_GAP_PX,
    marginBottom: HEADER_DIVIDER_GAP_PX,
    borderBottom: `1px solid ${dividerColor}`,
  };
}
